export const pricingTiers = [
    {
      id: 'bronze',
      name: 'Bronze',
      vehicles: { small: 30, medium: 35, large: 40, suv: 45 },
    },
    {
      id: 'silver',
      name: 'Silver',
      vehicles: { small: 50, medium: 60, large: 70, suv: 80 },
    },
    {
      id: 'gold',
      name: 'Gold',
      vehicles: { small: 85, medium: 100, large: 115, suv: 130 },
    },
    {
      id: 'platinum',
      name: 'Platinum',
      vehicles: { small: 140, medium: 165, large: 190, suv: 215 },
    },
  ];
  
  export const vehicleTypes = [
    { id: 'small', name: 'Small Car', examples: 'Fiat 500, Mini, Toyota Yaris' },
    { id: 'medium', name: 'Medium Car', examples: 'VW Golf, Ford Focus, Honda Civic' },
    { id: 'large', name: 'Large Car', examples: 'BMW 5 Series, Audi A6, Mercedes E-Class' },
    { id: 'suv', name: 'SUV/4x4', examples: 'Range Rover, BMW X5, Nissan Qashqai' },
  ];